import { SET_FORM_DATA, SET_FORM_FLAG, SET_ISSUE_LIST, SET_ISSUS_DETAILS, SET_ISSUS_TYPE, SET_LOADER, SET_SEARCH_DATA } from "./types";

/* eslint-disable import/no-anonymous-default-export */
const initialState = {
  loader: false,
  issueFormFlag: false,
  formData: {},
  issueDetail: {},
  type: "",
  issueList: {},
  search: { date: false, searchValue: '' }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_FLAG:
      return {
        ...state,
        issueFormFlag: action?.payload,
      };

    case SET_LOADER:
      return {
        ...state,
        loader: action?.payload,
      };

    case SET_ISSUS_DETAILS:
      return {
        ...state,
        issueDetail: { ...action?.payload }
      };

    case SET_FORM_DATA:
      return {
        ...state,
        formData: { ...action?.payload }
      };

    case SET_ISSUS_TYPE:
      return {
        ...state,
        type: action?.payload
      };

    case SET_ISSUE_LIST:
      return {
        ...state,
        issueList: action?.payload
      };

    case SET_SEARCH_DATA:
      return {
        ...state,
        search: { ...state.search, ...action?.payload }
      };

    default:
      return { ...state };
  }
};
